<template>
  <div class="emd-panel__section eu-mb_4">
    <div class="emd-panel__block">
      <div class="el-chunk">
        <emd-text
          tag="h2"
          size="medium"
          type="caption"
          >{{ $t('personal_data') }}
        </emd-text>
      </div>
    </div>
    <div class="emd-panel__block">
      <div class="el-chunk">
        <emd-text
          size="tiny"
          tag="p"
          type="label"
          variation-color="subtle"
        >
          {{ $t('name') }}
        </emd-text>
        <emd-text
size="medium"
          >{{ user.first_name }} {{ user.last_name }}</emd-text
        >
      </div>
      <div class="el-chunk">
        <emd-text
          size="tiny"
          tag="p"
          type="label"
          variation-color="subtle"
        >
          {{ $t('email') }}
        </emd-text>
        <emd-text size="medium">{{ user.email }}</emd-text>
      </div>
      <div class="el-chunk">
        <emd-text
          size="tiny"
          tag="p"
          type="label"
          variation-color="subtle"
          >{{ $t('permission') }}</emd-text
        >
        <emd-text
          size="medium"
          type="caption"
          >{{ user.permission }}</emd-text
        >
      </div>
      <div class="el-grid-list">
        <div class="el-chunk">
          <emd-text
            size="tiny"
            tag="p"
            type="label"
            variation-color="subtle"
          >
            {{ $t('phone') }}
          </emd-text>
          <emd-text size="medium">{{ user.phone }}</emd-text>
        </div>
        <div class="el-chunk">
          <emd-text
            size="tiny"
            tag="p"
            type="label"
            variation-color="subtle"
          >
            {{ $t('document') }}
          </emd-text>
          <emd-text size="medium">{{ user.document_number }}</emd-text>
        </div>
      </div>

      <div class="el-grid-list">
        <div class="el-chunk">
          <emd-text
            size="tiny"
            tag="p"
            type="label"
            variation-color="subtle"
          >
            {{ $t('create_date') }}
          </emd-text>
          <emd-text size="medium">{{ user.created_at }}</emd-text>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EmdText } from 'emerald-vue/src/components'

export default {
  name: 'UserPersonalData',
  components: {
    EmdText
  },
  props: {
    user: Object
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "personal_data": "Dados do usuário",
    "create_date": "Criado em",
    "updated_date": "Atualizado em",
    "name": "Nome",
    "email": "Email",
    "phone": "Telefone",
    "document": "Documento",
    "permission": "Perfil de acesso"
  },
  "en-US": {
    "personal_data": "Personal Data",
    "create_date": "Created At",
    "updated_date": "Updated At",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "document": "Document",
    "permission": "Permission"
  }
}
</i18n>
